"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerationSelect = void 0;
var GenerationSelect_component_1 = require("./GenerationSelect/GenerationSelect.component");
Object.defineProperty(exports, "GenerationSelect", { enumerable: true, get: function () { return __importDefault(GenerationSelect_component_1).default; } });
